import loadDailyTextData from "./epics/loadDailyTextData";
import loadUserData from "./epics/loadUserData";
import loadTodos from "./epics/loadTodos";

export default function(store, { user_id }) {
  return Promise.all([
    store.dispatch(loadDailyTextData({ user_id })),
    store.dispatch(loadUserData({ user_id }))
    // store.dispatch(loadTodos({ user_id }))
  ]);
}



// WEBPACK FOOTER //
// ./src/store/boot.js